export default __webpack_public_path__ + "static/media/detektiv-image-cropped.7dd1e5d7.svg";